export default {
  de: 'German',
  en: 'English'
}



// WEBPACK FOOTER //
// ./src/i18n/en/lang.js